import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private menuItems$ = new BehaviorSubject<MenuItem[]>([
    {
      label: 'Notificações',
      icon: 'notifications_active',
      route: '/notification',
    },
    {
      label: 'Buscar cliente',
      icon: 'search',
      route: '/coupon',
    },
    {
      label: 'Histórico',
      icon: 'history',
      route: '/coupon/purchase-history',
    },
  ]);

  public menuItems = this.menuItems$.asObservable();
}
